









import Vue from 'vue';
import PreloadAppScreen from "@/components/templates/PreloadAppScreen.vue";
import {VueEventTypes} from "@/events/AppEvent";

export default Vue.extend({
  name: 'App',

  components: {
    PreloadAppScreen
  },

  data: () => ({
    loading: true
  }),

  created(): void {
    this.$eventHub.$on(VueEventTypes.APP_LOAD_COMPLETE, this.loadedAppComplete);
  },

  mounted(): void {
    console.log('App Mounted');
  },

  methods: {
    loadedAppComplete (): void {
      console.log("App Loaded");
      this.loading = false;
    }
  }
});
